import { jsx as _jsx } from "react/jsx-runtime";
import { Board } from "../board";
import { useFrame } from '@react-three/fiber';
import { useEffect, useRef } from 'react';
export const AnimatedBoard = ({ animation, animEpoch, playing, position, rotation, ...boardProps }) => {
    const meshRef = useRef(null);
    const tRef = useRef(0);
    const dirRef = useRef(1);
    useEffect(() => {
        tRef.current = 0;
        dirRef.current = 1;
    }, [animEpoch]);
    useFrame((_, delta) => {
        if (!meshRef.current)
            return;
        const dur = (animation.durationMs ?? 1500) / 1000;
        if (playing) {
            tRef.current += (delta / dur) * dirRef.current;
            if (tRef.current >= 1) {
                tRef.current = 1;
                if (animation.loop)
                    dirRef.current = -1;
            }
            else if (tRef.current <= 0) {
                tRef.current = 0;
                if (animation.loop)
                    dirRef.current = 1;
            }
        }
        const val = animation.from + (animation.to - animation.from) * tRef.current;
        if (animation.target === 'rotation') {
            const r = [...rotation];
            r[animation.axis] = val;
            meshRef.current.rotation.set(r[0], r[1], r[2]);
        }
        else {
            const p = [...position];
            p[animation.axis] = val;
            meshRef.current.position.set(p[0], p[1], p[2]);
        }
    });
    return _jsx(Board, { ref: meshRef, position: position, rotation: rotation, ...boardProps });
};
